import { useEffect, useMemo, useState } from "react";

import { useNode } from "@craftjs/core";

import createContextFactory from "@/utils/factory";

import { useBlockLevelState } from "./block-level";

const { Provider, useContext } = createContextFactory(({ definition, getParentId, setParentLevel }) => {
  const parent = useParent(getParentId)
  const blockLevel = useBlockLevelState(setParentLevel)

  return useMemo(() => ({
    parent,
    definition,
    blockLevel,
  }), [definition, parent, blockLevel])
})

/**
 * @param {() => string} getParentId
 */

function useParent(getParentId) {
  const { id } = useNode()
  const [isValidParent, setIsValidParent] = useState(false)

  return useMemo(() => ({
    setIsValidParent,
    getId: () => isValidParent ? id : getParentId?.() ?? null,
    getParentId,
  }), [id, isValidParent, getParentId])
}

export function DefinitionProvider({ children, ...props }) {
  const { parent: { getId } = {}, blockLevel: { setLevel } = {} } = useContext()

  return <Provider getParentId={getId} setParentLevel={setLevel} {...props}>
    {children}
  </Provider>
}

export function useCloseParent() {
  const { parent: { setIsValidParent, getParentId } } = useContext()

  useEffect(() => {
    setIsValidParent(true)
  }, [setIsValidParent])

  return getParentId()
}

export {
  useContext as useDefinitionContext,
}
